/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../../apiClient'
import type {
  ListDocumentFileExtensionsQueryResponse,
  ListDocumentFileExtensionsQueryParams,
} from '../../types/ListDocumentFileExtensions'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { listDocumentFileExtensions } from '../../clients/listDocumentFileExtensions'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const listDocumentFileExtensionsQueryKey = (
  params?: ListDocumentFileExtensionsQueryParams
) =>
  [
    { url: '/api/v1/documents/file-extensions/' },
    ...(params ? [params] : []),
  ] as const

export type ListDocumentFileExtensionsQueryKey = ReturnType<
  typeof listDocumentFileExtensionsQueryKey
>

export function listDocumentFileExtensionsQueryOptions(
  params?: ListDocumentFileExtensionsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = listDocumentFileExtensionsQueryKey(params)
  return queryOptions<
    ListDocumentFileExtensionsQueryResponse,
    ResponseErrorConfig<Error>,
    ListDocumentFileExtensionsQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return listDocumentFileExtensions(params, {
        ...config,
        signal: config.signal ?? signal,
      })
    },
  })
}

/**
 * @description Get unique file extensions for user's company documents.
 * Returns list of objects with label and value for use in filters:
 * [
 * {"label": "PDF", "value": "pdf"},
 * {"label": "DOCX", "value": "docx"},
 * ...
 * ]
 * @summary List distinct file extensions in the library
 * {@link /api/v1/documents/file-extensions/}
 */
export function useListDocumentFileExtensions<
  TData = ListDocumentFileExtensionsQueryResponse,
  TQueryData = ListDocumentFileExtensionsQueryResponse,
  TQueryKey extends QueryKey = ListDocumentFileExtensionsQueryKey,
>(
  params?: ListDocumentFileExtensionsQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ListDocumentFileExtensionsQueryResponse,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey =
    resolvedOptions?.queryKey ?? listDocumentFileExtensionsQueryKey(params)

  const query = useQuery(
    {
      ...listDocumentFileExtensionsQueryOptions(params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
